import { createRoute, createRouter } from "@tanstack/react-router";
import { Route as rootRoute } from "./routes/__root";
import { CatalogPage } from "./routes/CatalogPage";
import { GamePage } from "./routes/GamePage";
import { AboutPage } from "./routes/AboutPage";
import { type CatalogSearch, type Shelf } from "./lib/types";

const SHELVES: Shelf[] = ["playable", "multiplayer", "flash", "java", "lab"];

// Catalog filter state lives in the URL search params, so a filtered/searched
// view is shareable and survives back/forward and refresh.
const catalogRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  validateSearch: (search: Record<string, unknown>): CatalogSearch => ({
    shelf: SHELVES.includes(search.shelf as Shelf) ? (search.shelf as Shelf) : "playable",
    q: typeof search.q === "string" ? search.q : "",
    cat: typeof search.cat === "string" ? search.cat : "",
    src: typeof search.src === "string" ? search.src : "",
    sort: search.sort === "plays" ? "plays" : "az",
  }),
  component: CatalogPage,
});

export interface GameSearch {
  catalog?: string;
  forceLaunch?: boolean;
}

const gameRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/game/$id",
  validateSearch: (search: Record<string, unknown>): GameSearch => ({
    catalog: typeof search.catalog === "string" ? search.catalog : undefined,
    forceLaunch:
      search.forceLaunch === "1" || search.forceLaunch === 1 || search.forceLaunch === true || undefined,
  }),
  component: GamePage,
});

const aboutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/about",
  component: AboutPage,
});

const routeTree = rootRoute.addChildren([catalogRoute, gameRoute, aboutRoute]);

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
